/* eslint-disable */
/**
 * 代理配置
 */
import Vue from 'vue'
import store from '../store'
import menuEnKey from './languages/menuEnKey'
//import "../../public/static/key.js"
export const NODE_ENV = process.env.NODE_ENV
export const bdInstance = 'IOTECH-SERVER-BD/'

export const wsInstance = process.env.VUE_APP_BASE_API
export const downBaseUrl = wsInstance + "/IOT-SERVER-ES"
// export const downBaseUrl = wsInstance + "/IOT-SERVER-ES-TEST"
export const imgBaseUrl = process.env.VUE_APP_IMG_URL
export const fileBaseUrl = process.env.VUE_APP_FILE_URL
export const invUrl = process.env.VUE_APP_INV_URL

let host = realHost()
export const bigUrl = keyset[host]?.BIG_BASE_API || (window.location.origin + ":187") //process.env.VUE_APP_BIG_BASE_API
export const tianMapToken = keyset[host]?.Tian_MAP_TOKEN || process.env.VUE_APP_Tian_MAP_TOKEN
export const cesiumToken = keyset[host]?.CESIUM_TOKEN || process.env.VUE_APP_CESIUM_TOKEN
export const publicKey = keyset[host]?.PUBLIC_KEY || process.env.VUE_APP_PUBLIC_KEY
export const priviteKey = keyset[host]?.PRIVITE_KEY || process.env.VUE_APP_PRIVITE_KEY
export const routeWhiteList = ['/login', '/testLogin', '/avoidLogin', '/bigLogin', 'createProject', '/platform/createProject', 'projectList', 'initProject', 'factorInfo', '/customized/weighingMonitor', '/customized/temperature', '/customized/ds9']

console.log("keys", tianMapToken, cesiumToken, publicKey, priviteKey, bigUrl)
import i18n from '@/utils/i18n'
import { getMagnification, getLanguage } from '@/utils/auth'

// 包了一层，打包后会保留i18n这个名字
const myI18n = {
	i18n: i18n
}

export const languageList = [
	{ label: '简', command: 'zh-CN' },
	{ label: '繁', command: 'zh-TW' },
	{ label: 'English', command: 'en' }
]

export const otherMenuList = [
	//$t('重点监控')
	{
		specialCode: "key_monitor",
		name: "factorInfo",
		title: myI18n.i18n.t("重点监控"),
		code: "projectMonitor",
		path: "/platform/projectMonitor",
		children: [],
		icon: "zdjk",
	},
	{
		specialCode: "group_preview",
		name: "factorInfo",
		title: myI18n.i18n.t("分组预览"),
		code: "dataReport",
		path: "/platform/dataReport",
		children: [],
		icon: "fzyl",
	},
]
export function getCurrentLangLabel(language) {
	let obj = languageList.find(item => item.command == language) || {}
	return obj.label || ''
}
export function realHost() {
	let host = window.location.host
	if (host.indexOf("www") === 0) {
		host = host.slice(4)
	}
	return host
}

export function cancel() {
	store.state.loadding = false
	Object.keys(Vue.prototype.$source).forEach(item => {
		//取消请求
		Vue.prototype.$source[item] && Vue.prototype.$source[item]('用户取消');
		Vue.prototype.$source[item] = null;
	})
}

export function hideLoading() {
	store.state.loadding = false
}

export function cancelSingle(item) {
	console.log(item)
	console.log(Vue.prototype.$source)
	Vue.prototype.$source[item] && Vue.prototype.$source[item]('用户取消');
	Vue.prototype.$source[item] = null;
}

/**
 * 最小二乘法拟合多项式曲线，并确定最佳多项式阶数
 */
function F(c, Em, l, m) {
	let result = 0;
	for (let i = l; i <= m; i++) {
		result = result + Em[l - 1][i] * c[i];
	}
	return result;
}
function newArr(size) {
	/*let arr = [];
	for(let i=0;i<size;i++){
		arr.push(null)
	}*/
	return new Array(size)
}
function CalEquation(exp, Em, coefficient) {
	for (let k = 0; k <= exp - 2; k++) {//消元过程
		for (let i = k + 1; i <= exp - 1; i++) {
			let p1 = 0;
			if (Em[k][k] != 0) {
				p1 = Em[i][k] / Em[k][k];
			}
			for (let j = k; j <= exp; j++) {
				Em[i][j] = Em[i][j] - Em[k][j] * p1;
			}
		}
	}
	coefficient[exp - 1] = Em[exp - 1][exp] / Em[exp - 1][exp - 1];
	for (let l = exp - 2; l >= 0; l--) {
		//回代求解
		coefficient[l] = (Em[l][exp] - F(coefficient, Em, l + 1, exp - 1)) / Em[l][l];
	}
	//console.log("rrrrrrrr",coefficient)
	return coefficient;
}
function RelateMutiXY(Vx, Vy, ex) {
	let result = 0, n = Vx.length;
	for (let i = 0; i <= n - 1; i++) {
		result = result + Math.pow(Vx[i], ex) * Vy[i];
	}
	return result;
}
function RelatePow(Vx, ex) {
	let result = 0, n = Vx.length;
	for (let i = 0; i <= n - 1; i++) {
		result = result + Math.pow(Vx[i], ex);
	}
	return result;
}
function EMatrix(Vx, Vy, ex, coefficient) {
	let Em = newArr(ex),
		n = Vx.length;
	for (let i = 0; i <= ex - 1; i++) {
		Em[i] = newArr(ex + 1)
	}
	for (let i = 0; i <= ex - 1; i++) {
		for (let j = 0; j <= ex - 1; j++) {
			Em[i][j] = RelatePow(Vx, i + j);
		}
		Em[i][ex] = RelateMutiXY(Vx, Vy, i);
	}
	Em[0][0] = n;
	return CalEquation(ex, Em, coefficient);
}
export function getDecimal(value) {
	let count = (value + '').split('.')[1] ? ((value + '').split('.')[1].length) : 1//小数位
	let decimal = Math.pow(10, count)
	return decimal
}
//*===polyfit(n,x,y,poly_n,a)最小二乘法拟合多项式曲线，并确定最佳多项式阶数===================*/
// 输入：n:数组个数   x,y:数组x,y
// 输出：poly_n：返回拟合函数的最佳阶数 最多10阶
// coefficient:返回系数   y=coefficient[0]+coefficient[1]*x+coefficient[2]*x^2+coefficient[3]*x^3+...+coefficient[n]*x^n  调用前setlength(coefficient,10)
//     newy:返回拟合后的Y数组     调用前setlength(newy,n)
function polyfit(arr) {
	let n = arr.length,
		x = arr.map((item, index) => { return index }),
		y = arr.map((item, index) => { return item[1] }),
		decimal = getDecimal(y[0]),
		coefficient = newArr(10),
		mse = newArr(10),
		p = newArr(10),
		newy = newArr(n);
	for (let i = 2; i <= 11; i++) {
		p[i] = newArr(i + 1);
		coefficient = EMatrix(x, y, i + 1, p[i]);
		mse[i] = 0;
		for (let j = 0; j <= n - 1; j++) {
			let d = 0;
			for (let k = 0; k <= i; k++) {
				d = d + p[i][k] * Math.pow(x[j], k);
			}
			d = Math.trunc(d * 100) / 100;
			mse[i] = mse[i] + (y[j] - d) * (y[j] - d);
		}
		mse[i] = Math.trunc(Math.sqrt(mse[i] / n) * 100) / 100;
	}
	let min = mse[2];
	let poly_n = 2;
	for (let i = 3; i <= 10; i++) {
		if (mse[i] < min) {
			poly_n = i;
			min = mse[i];
		}
	}
	for (let i = 0; i <= Math.max(...coefficient); i++) {
		coefficient[i] = 0;
	}
	for (let i = 0; i <= poly_n; i++) {
		coefficient[i] = p[poly_n][i];
	}
	for (let i = 0; i <= n - 1; i++) {
		let d = 0;
		for (let k = 0; k <= poly_n; k++) {
			d = d + coefficient[k] * Math.pow(x[i], k);
		}
		newy[i] = Math.trunc(d * decimal) / decimal;
	}
	return newy
}
export function getPolyfit(arr) {
	let newy = polyfit(arr)
	return newy.map((it, index) => { return [index, it] });
}
export function getLinePolyfit(arr) {
	let newy = polyfit(arr)
	return newy.map((it, index) => { return [arr[index][0], it] });
}


//数组去重
export function unique(arr) {
	return [...new Set(arr)]
}
function hasClass(ele, cls) {
	return !!ele.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'))
}
export function addClass(ele, cls) {
	if (!hasClass(ele, cls)) ele.className += ' ' + cls
}
export function removeClass(ele, cls) {
	if (hasClass(ele, cls)) {
		const reg = new RegExp('(\\s|^)' + cls + '(\\s|$)')
		ele.className = ele.className.replace(reg, ' ')
	}
}
export function sortByArr(sortList, itemList) {
	itemList.sort((i, j) => sortList.indexOf(i.pointId) - sortList.indexOf(j.pointId))
	return itemList;
}
/*
	function: dateFormat
	params: format:格式
					date:  日期值
	功能:将日期以指定格式输出
	返回:指定形式的日期字符串
*/
export function dateFormat(format, date = new Date()) {
	// const realDate = date || new Date()
	if (!date) { return }
	const realDate = new Date(date)
	let milliseconds = realDate.getMilliseconds() + ''
	while (milliseconds.length < 3) {
		milliseconds = '0' + milliseconds
	}
	const obj = {
		'M+': realDate.getMonth() + 1,
		'd+': realDate.getDate(),
		'h+': realDate.getHours(),
		'm+': realDate.getMinutes(),
		's+': realDate.getSeconds(),
		'q+': Math.floor((realDate.getMonth() + 3) / 3), // 季度
		'S': milliseconds // 毫秒
	}
	if (/(y+)/.test(format)) {
		format = format.replace(RegExp.$1, (realDate.getFullYear() + '').substr(4 - RegExp.$1.length))
		for (var k in obj) {
			if (new RegExp('(' + k + ')').test(format)) {
				format = format.replace(RegExp.$1, (RegExp.$1.length === 1) ? (obj[k]) : (('00' + obj[k]).substr(('' + obj[k]).length)))
			}
		}
	}
	return format
}
export function getConfig(datas, singleArr) {
	let magnification = getMagnification()
	if (datas) {
		singleArr = datas.map(it => { return it[1] });
	}
	let maxXAxis = Math.max(...singleArr),
		minXAxis = Math.min(...singleArr),
		scale = parseFloat(Math.abs(maxXAxis - minXAxis) / 6 * 1000) / 1000
	scale = scale * magnification;
	maxXAxis = Math.ceil((scale + maxXAxis) * 1000) / 1000 //向上取整 保留3位小数
	minXAxis = Math.floor((minXAxis - scale) * 1000) / 1000 //向下取整保留3位小数
	if (maxXAxis == minXAxis) {
		maxXAxis = maxXAxis + 0.5;
		minXAxis = minXAxis - 0.5;
	}
	if (scale > 1 && maxXAxis > 10) {
		maxXAxis = parseFloat(maxXAxis.toFixed(0))
	}
	return {
		maxXAxis: maxXAxis,
		minXAxis: minXAxis
	}
}
function getMaxOrMin(max, min) {
	let magnification = getMagnification(),
		scale = parseFloat(Math.abs(max - min) / 6 * 1000) / 1000
	scale = scale * magnification;
	max = Math.ceil((scale + max) * 1000) / 1000 //向上取整 保留2位小数
	min = Math.floor((min - scale) * 1000) / 1000 //向下取整保留2位小数
	if (max == min) {
		max = max + 0.5;
		min = min - 0.5;
	}
	return {
		max: max,
		min: min
	}
}
export function getMax(value) {
	let item = getMaxOrMin(value.max, value.min)
	return item.max
}
export function getMin(value) {
	let item = getMaxOrMin(value.max, value.min)
	return item.min
}
export function getTimes(series) {
	let times = []
	series.forEach(item => {
		item.data.forEach(it => {
			if (it.value) {
				times.push(it.value[0])
			} else {
				times.push(it[0])
			}
		})
	})
	times = unique(times)
	return times.sort();
}
export function downFile(url) {

	try {
		var downLoadElement = document.createElement("a");
		downLoadElement.href = url;
		downLoadElement.style.display = "none";
		document.body.appendChild(downLoadElement);
		downLoadElement.click()
		document.body.removeChild(downLoadElement);
	} catch (e) {

	}
}

/**
 * @description: 将后端返回的流文件下载
 * @param {any} res
 * @return {*}
 */
export function downLoadXlsx(res, fileName) {
	// 处理返回的文件流
	const content = res
	const blob = new Blob([content], {
		type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
	});
	if ('download' in document.createElement('a')) {
		//非IE下载
		const a = document.createElement('a') //创建一个a标签
		a.download = fileName ? fileName : '列表'//指定文件名称
		a.style.display = 'none' //页面隐藏
		a.href = URL.createObjectURL(blob) // href用于下载地址
		document.body.appendChild(a) //插到页面上
		a.click() //通过点击触发
		URL.revokeObjectURL(a.href) //释放URL 对象
		document.body.removeChild(a) //删掉a标签

	}
}

export function parseParam(param, key) {
	var _this = this;
	var paramStr = "";
	Object.keys(param).forEach(i => {
		paramStr += i + "=" + param[i] + "&"
	})
	return paramStr.slice(0, -1);
}
export function isNumberArr(arr) {
	let flag = true;
	arr.forEach(item => {
		let value = Number(item);
		if (!value && value != 0) {
			flag = false
		}
	})
	return flag
}
let lang = getLanguage();
function menus(data, keyData, parentCode) {
	data.forEach(item => {
		item.path = item.href
		let menuName = item.name;
		item.title = menuName;
		if (lang == 'en') {
			item.title = menuEnKey[item.code] || item.title
		}
		item.name = item.code;
		item.children = item.menus;
		item.hasPromiss = true;//默认此菜单有权限
		keyData[item.path] = item;
		if (item.children.length) {
			let ob = item.children[0]
			item.redirect = ob.href
			if (ob.menus.length) {
				item.redirect = ob.menus[0].href;
			}
			menus(item.children, keyData, item.path)
		}
	})
}
export function calcuMenu(data) {
	let keyData = {};
	menus(data, keyData, data.code)
	return { routers: data, keyData: keyData };
}
export function goHome(projectInfo, hasEarth) {
	if (projectInfo.type == '-10') {
		return "/bridge/bridgeHomePage"
	} else {
		return "/platform/projectOverviewBIM"
	}
}
export function goFirstPage() {
	let routers = store.state.permission.routers
	return routers[0].path;
}

// 判断是否是管内测斜与静力水准仪
export function isDisplacementOrinclinometer(item) {
	return item.macroCode == 'pipeline_inclinometer' || item.macroCode == 'static_level_displacement'
}
export function notIncilinometerAndDisplacement(item) {
	return item.macroCode != 'pipeline_inclinometer' && item.macroCode != 'static_level_displacement'
}
/**
 * 功能:获取事件触发的DOM元素
 *
 */
export function getDomEleByEvent(e) {
	let event = e || window.event
	let ele = event.target || event.srcElement
	return ele
}

export function getFileInfo(fileName) {
	//filePath = filePath.split('?')[0]; //去参数
	var re = /([^\.\/\\]+)\.([a-z]+)$/i,
		resultArr = re.exec(fileName),
		info = {};
	if (resultArr) {
		info.name = resultArr[1];
		info.type = resultArr[2];
		info.fullname = resultArr[1] + '.' + resultArr[2]
	}
	return info
}

/***
 * 将时间戳转成日期时间
 *
 * params:time（时间戳）
 */
export function formatTime(number, format) {

	var formateArr = ['Y', 'M', 'D', 'h', 'm', 's'];
	var returnArr = [];

	var date = new Date(number);
	returnArr.push(date.getFullYear());
	returnArr.push(formatNumber(date.getMonth() + 1));
	returnArr.push(formatNumber(date.getDate()));

	returnArr.push(formatNumber(date.getHours()));
	returnArr.push(formatNumber(date.getMinutes()));
	returnArr.push(formatNumber(date.getSeconds()));

	for (var i in returnArr) {
		format = format.replace(formateArr[i], returnArr[i]);
	}
	return format;
}

//数据转化
function formatNumber(n) {
	n = n.toString()
	return n[1] ? n : '0' + n
}

export function getWeatherImgSrc(weather) {
	let img = '../../static/imgs/weather/多云.png'
	if (weather.indexOf('晴') != -1) {
		img = '../../static/imgs/weather/晴.png'
	}
	else if (weather.indexOf('多云') != -1) {
		img = '../../static/imgs/weather/多云.png'
	}
	else if (weather.indexOf('阴') != -1) {
		img = '../../static/imgs/weather/阴.png'
	}
	else if (weather.indexOf('雨') != -1) {
		img = '../../static/imgs/weather/雨.png'
	}
	else if (weather.indexOf('阵雨') != -1) {
		img = '../../static/imgs/weather/阵雨.png'
	}
	else if (weather.indexOf('小雨') != -1) {
		img = '../../static/imgs/weather/小雨.png'
	}
	else if (weather.indexOf('中雨') != -1) {
		img = '../../static/imgs/weather/中雨.png'
	}
	else if (weather.indexOf('雪') != -1) {
		img = '../../static/imgs/weather/中雪.png'
	}
	else if (weather.indexOf('小雪') != -1) {
		img = '../../static/imgs/weather/小雪.png'
	}
	else if (weather.indexOf('中雪') != -1) {
		img = '../../static/imgs/weather/中雪.png'
	}
	else if (weather.indexOf('冰雹') != -1) {
		img = '../../static/imgs/weather/冰雹.png'
	}
	else if (weather.indexOf('大雪') != -1) {
		img = '../../static/imgs/weather/大雪.png'
	}
	else if (weather.indexOf('扬沙') != -1) {
		img = '../../static/imgs/weather/扬沙.png'
	}
	else if (weather.indexOf('沙尘暴') != -1) {
		img = '../../static/imgs/weather/沙尘暴.png'
	}
	else if (weather.indexOf('浮尘') != -1) {
		img = '../../static/imgs/weather/浮尘.png'
	}
	else if (weather.indexOf('阵雨') != -1) {
		img = '../../static/imgs/weather/阵雨.png'
	}
	else if (weather.indexOf('阵雪') != -1) {
		img = '../../static/imgs/weather/阵雪.png'
	}
	else if (weather.indexOf('雨夹雪') != -1) {
		img = '../../static/imgs/weather/雨夹雪.png'
	}
	else if (weather.indexOf('雷') != -1) {
		img = '../../static/imgs/weather/雷电.png'
	}
	else if (weather.indexOf('雷阵雨') != -1) {
		img = '../../static/imgs/weather/雷阵雨.png'
	}
	else if (weather.indexOf('雾') != -1) {
		img = '../../static/imgs/weather/雾.png'
	}
	else if (weather.indexOf('霾') != -1) {
		img = '../../static/imgs/weather/霾.png'
	}
	return img
}


/*
* 判断文件上传是否符合规定
* files:file 文件列表
* sum:number 文件大小总数，默认50M
* single:number 单个文件大小控制,不传就是不控制
* */
export function fileLegal(files, sum, single) {
	if (!sum) {
		let sum = 50
	}
	let total = 0
	for (let i = 0; i < files.length; i++) {
		if (single) {
			if (files[i].size / 1024 / 1024 > single) {
				return false
			}
		}
		if (files[i].size) {
			total += files[i].size / 1024 / 1024
		}
	}
	if (total > sum) {
		return false
	} else {
		return true
	}
}

/*
* 动态更改ico
* */
export function changeFavicon(link) {
	let $favicon = document.querySelector('link[rel="icon"]');
	// If a <link rel="icon"> element already exists,
	// change its href to the given link.
	if ($favicon !== null) {
		$favicon.href = link;
		// Otherwise, create a new element and append it to <head>.
	} else {
		$favicon = document.createElement("link");
		$favicon.rel = "shortcut icon";
		$favicon.href = link;
		document.head.appendChild($favicon);
	}
}

/*
* 判断地址的二级域名
* */
export function getDomainPrefix(url) {
	if (url) {
		console.log(url)
		let ret = url.replace(/^\//g, '').replace(/\/$/g, '').split('/')
		console.log(ret)
		let res = ret[ret.length - 1]
		console.log(res)
		return res
	} else {
		return ''
	}
}
export function getNameGap(max) {
	let nameGap = max.toFixed(0).length * 9
	return nameGap > 30 ? nameGap : 30
}
/*
* 获取url里的参数
* */
export function getParams(linkUrl) {
	let url = decodeURI(linkUrl || window.location.href)
	let params = url.split("?")
	if (params.length > 1) {
		let arr = params[1].split("&")
		let config = {}
		for (let i = 0; i < arr.length; i++) {
			let keyval = arr[i].split('=')
			if (keyval.length > 1) {
				config[keyval[0]] = keyval[1]
			}
		}
		return config
	} else {
		return false
	}
}
// export const flotWindowList = ['videoMonitor']
export const flotWindowList = []
/*
* 打开浮出窗口(浏览器新窗口)
* */
export function openOverflowWindow(url, config, width, height) {
	let domain = window.location.href.split('#')[0]
	let finalurl = domain + '#' + url
	let arr = []
	for (let keys in config) {
		console.log(keys, config[keys])
		arr.push(keys + '=' + config[keys])
	}
	let params = arr.join("&")
	if (arr.length > 0) {
		finalurl += "?" + params
	}
	let finalHeight = height || 500
	let finalWidth = width || 600
	let finalfeatures = "height=" + finalHeight + ", width=" + finalWidth + ", location=no,menubar=no,status=no,toolbar=no"
	window.open(finalurl, new Date().getTime(), finalfeatures)
}

/*
* 打开浮出窗口(平台内)
* name:组件名
* title:打开窗口的标题
* config:要传递的参数
* width:打开窗口宽度
* height:打开窗口高度
* */
export function openFloatDialog(name, title, config = {}, width = 600, height = 400) {
	store.commit('addFloatList', {
		"name": name,
		"title": title,
		"width": width,
		"height": height,
		"config": config
	})
}

/*
* 判断文件格式是否符合规定
* */
export function fileTypeLegal(files, types) {
	let typeslist = types.map(item => item.toLowerCase())
	for (let i = 0; i < files.length; i++) {
		let filearr = files[i].name.split('.')
		let type = filearr[filearr.length - 1].toLowerCase()
		if (typeslist.indexOf(type) === -1) {
			return false
		}
	}
	return true
}

export function contentExtend(obj) {
	function F() { }
	F.prototype = obj
	return new F();
}

export const phyList = ['data1', 'data2', 'data3', 'data4', 'data5', 'data6']
export const phyCurObj = {
	data1: myI18n.i18n.t('数据') + '1',
	data2: myI18n.i18n.t('数据') + '2',
	data3: myI18n.i18n.t('数据') + '3',
	data4: myI18n.i18n.t('数据') + '4',
	data5: myI18n.i18n.t('数据') + '5',
	data6: myI18n.i18n.t('数据') + '6'
}
export const statusObj = {
	0: myI18n.i18n.t('可用'),
	1: myI18n.i18n.t('手动标记异常'),
	2: myI18n.i18n.t('超量程'),
	3: myI18n.i18n.t('突变'),
	4: myI18n.i18n.t('无单位'),
	5: myI18n.i18n.t('缺水'),
	7: myI18n.i18n.t('补录'),
	8: myI18n.i18n.t('补录且突变'),
	9: myI18n.i18n.t('补录且超量程'),
	10: myI18n.i18n.t('补录且无单位'),
}
export const statusColor = {
	1: '#FFCD42',
	2: '#FFAA25',
	3: '#E18D79',
	4: '#D84C29',
	5: '#FF0000',

	7: '#20CAFD',
	8: '#12ADC9',
	9: '#4E91FD',
	10: '#033E8E',
}
export const colors = ['rgba(240, 55, 56,0.3)', 'rgba(0, 149, 233,0.3)', 'rgba(150, 207, 29,0.3)', 'rgba(64, 201, 198,0.3)', 'rgba(200, 178, 244,0.3)', 'rgba(255, 203, 140,0.3)', 'rgba(237, 134, 140,0.3)', 'rgba(103, 194, 58,0.3)', 'rgba(255, 170, 37,0.3)', 'rgba(255, 255, 0,0.3)', 'rgba(205, 196, 207,0.3)']
export const colors2 = ['rgba(240, 55, 56,0)', 'rgba(0, 149, 233,0)', 'rgba(150, 207, 29,0)', 'rgba(64, 201, 198,0)', 'rgba(200, 178, 244,0)', 'rgba(255, 203, 140,0)', 'rgba(237, 134, 140,0)', 'rgba(103, 194, 58,0)', 'rgba(255, 170, 37,0)', 'rgba(255, 255, 0,0)', 'rgba(205, 196, 207,0)']
export const colors3 = ['rgba(240, 55, 56,1)', 'rgba(0, 149, 233,1)', 'rgba(150, 207, 29,1)', 'rgba(64, 201, 198,1)', 'rgba(200, 178, 244,1)', 'rgba(255, 203, 140,1)', 'rgba(237, 134, 140,1)', 'rgba(103, 194, 58,1)', 'rgba(255, 170, 37,1)', 'rgba(255, 255, 0,1)', 'rgba(205, 196, 207,1)']
export const colors4 = ['rgba(240, 55, 56,0.2)', 'rgba(0, 149, 233,0.2)', 'rgba(150, 207, 29,0.2)', 'rgba(64, 201, 198,0.2)', 'rgba(200, 178, 244,0.2)', 'rgba(255, 203, 140,0.2)', 'rgba(237, 134, 140,0.2)', 'rgba(103, 194, 58,0.2)', 'rgba(255, 170, 37,0.2)', 'rgba(255, 255, 0,0.2)', 'rgba(205, 196, 207,0.2)']

export const sizeOption = [500, 1000, 5000, 10000]
export const colorList = ['#6A44EB', '#BB7F19', '#1E7CDB', '#CAB420', '#20C5CA', '#BE44EB', '#00CC6E']

export const timeSlots = [
	{ label: myI18n.i18n.t('最近一天'), value: 'oneDay' },
	{ label: myI18n.i18n.t('最近一周'), value: 'week' },
	{ label: myI18n.i18n.t('最近一月'), value: 'first' }
]
export const avgTypeList = [
	{ value: '', label: myI18n.i18n.t('按次') },
	{ value: 'hour', label: myI18n.i18n.t('每小时均值') },
	{ value: 'day', label: myI18n.i18n.t('每天均值') },
	{ value: 'week', label: myI18n.i18n.t('每周均值') }
]
export const avgTypeList2 = [
	{ value: '', label: myI18n.i18n.t('按次') },
	{ value: 'minute', label: myI18n.i18n.t('每分钟均值') },
	{ value: 'hour', label: myI18n.i18n.t('每小时均值') },
	{ value: 'day', label: myI18n.i18n.t('每天均值') },
	{ value: 'week', label: myI18n.i18n.t('每周均值') }
]
/*
* 判断密码强弱
* */
export function passwordStrenthFuc(password) {
	var reg = /^[0-9]{6,20}$|^[a-zA-Z]{6,20}$/; //全是数字或全是字母 6-16个字符
	var reg1 = /^[A-Za-z0-9]{6,20}$/; //数字、26个英文字母 6-16个字符
	var reg2 = /^\w{6,20}$/;  // 由数字、26个英文字母或者下划线组成的字符串 6-16个字符
	if (password.match(reg)) {
		return myI18n.i18n.t('弱')
	}
	else if (password.match(reg1)) {
		return myI18n.i18n.t('中等')
	}
	else {
		return myI18n.i18n.t('强')
	}
}

/*获取图片前缀*/
export function getImgUrl(path) {
	let str = "http"
	let str2 = "data:image"
	let ret = ''
	if (path.indexOf(str) == 0 || path.indexOf(str2) == 0) {
		ret = path
	} else {
		ret = imgBaseUrl + path
	}
	return ret
}

export function getWeekNumber(src) {
	if (!src) return null;
	var date = new Date(src.getTime());
	date.setHours(0, 0, 0, 0);
	// Thursday in current week decides the year.
	date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
	// January 4 is always in week 1.
	var week1 = new Date(date.getFullYear(), 0, 4);
	// Adjust to Thursday in week 1 and count number of weeks from date to week 1.
	// Rounding should be fine for Daylight Saving Time. Its shift should never be more than 12 hours.
	return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7);
};

export function prevDate(date) {
	var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	return new Date(date.getFullYear(), date.getMonth(), date.getDate() - amount);
};

export function nextDate(date) {
	var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

	return new Date(date.getFullYear(), date.getMonth(), date.getDate() + amount);
};

/*
* 查询数字字典方法
* */
export function queryDictionary(code) {
	return new Promise((resolve, reject) => {
		Vue.prototype.$httpSys.get("conf/macro/findByParentMacroCode/" + code).then(res => {
			resolve(res.data)
		}).catch((res => {
			reject(res)
		}))
	})
}

//上传文件获取文件路径
export function uploadFile(files) {
	return new Promise((resolve, reject) => {
		if (files.length) {
			let formData = new FormData()
			for (let i = 0; i < files.length; i++) {
				formData.append('file', files[i].raw)
			}
			Vue.prototype.$httpDisk.post('disk/file/uploadFilesToFtp', formData)
				.then(res => {
					resolve(res.data)
				}).catch(res => {
					reject(res)
				})
		} else {
			resolve([])
		}
	})
}

export function getMaxmin(arr, scale) {
	let temp = arr.sort((a, b) => a - b)
	let min = parseFloat(temp[0])
	let max = parseFloat(temp[temp.length - 1])
	return {
		min: -(max - min) * (scale - 1) + min,
		max: (max - min) * (scale - 1) + max
	}
}

export function hasValue(val) {
	if (val) {
		return true
	}
	if (val === 0) {
		return true
	}
	return false
}

export function validatePassword(rule, value, callback) {
	let reg = /(?!^\d{6-20}$)(?!^[a-zA-Z]{6,20}$)(?!^[0-9a-zA-Z]{6,20}$)^[0-9a-zA-Z~!@#$%^&*(),.?+-]{6,20}$/;// 6-18 数字和字母的组合和特殊字符
	if (reg.exec(value)) {
		callback()
	} else {
		callback(new Error(myI18n.i18n.t('密码由6-20位数字加字母加特殊字符组成')))
	}
}